import { gql } from '@apollo/client'

const FRAGMENT = gql`
  fragment PriorityPastMonthCompliance on PicOSPriorityStoreMonthCompliance {
    id
    storeName
    period1
    period2
    period3
    period4
    compliantDisplayAuditIds
  }
`

export const GET_PICOS_PRIORITY_PAST_MONTH_STORE_COMPLIANCE = gql`
  query GetPicOSPriorityPastMonthStoreCompliance(
    $input: PicOSPriorityComplianceInput!
  ) {
    picosPriorityPastMonthStoreCompliance(input: $input) {
      results {
        ...PriorityPastMonthCompliance
      }
      count
      hasMore
    }
  }
  ${FRAGMENT}
`
